<template>
  <div class="message" v-bind:class="classes">
    <span><i v-bind:class="icon"></i> {{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String
    },
    message: {
      type: String,
      required: true
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    icon: function() {
      switch (this.type) {
        case 'success':
          return 'icon--tick';
        case 'error':
          return 'icon--cross';
        default:
          return 'icon--info-circle';
      }
    },
    classes: function() {
      return {
        'message--block': !this.inline,
        'message--success': this.type === 'success',
        'message--error': this.type === 'error',
        'message--warning': this.type === 'warning'
      };
    }
  }
};
</script>
